import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center"
      >
        {/* Arlo Logo with hey bubble */}
        <div className="relative inline-block mb-6">
          <motion.div 
            className="absolute -top-2 left-1"
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.3 }}
          >
            <div 
              className="bg-white text-background px-2 py-1 rounded text-[12px] font-bold leading-none" 
              style={{ fontFamily: "'Coco Gothic', sans-serif" }}
            >
              hey
            </div>
            <div className="absolute -bottom-1 left-2.5 w-2 h-2 bg-white transform rotate-45"></div>
          </motion.div>
          <motion.span 
            className="text-6xl font-bold tracking-tight text-foreground" 
            style={{ fontFamily: "'Coco Gothic', sans-serif" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.3 }}
          >
            arlo
          </motion.span>
        </div>

        {/* Loading indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.3 }}
          className="flex items-center gap-1.5"
        >
          <motion.div
            className="w-2 h-2 bg-foreground/60 rounded-full"
            animate={{ scale: [1, 1.2, 1], opacity: [0.6, 1, 0.6] }}
            transition={{ duration: 1, repeat: Infinity, delay: 0 }}
          />
          <motion.div
            className="w-2 h-2 bg-foreground/60 rounded-full"
            animate={{ scale: [1, 1.2, 1], opacity: [0.6, 1, 0.6] }}
            transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
          />
          <motion.div
            className="w-2 h-2 bg-foreground/60 rounded-full"
            animate={{ scale: [1, 1.2, 1], opacity: [0.6, 1, 0.6] }}
            transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.3 }}
          className="mt-4 text-sm text-muted-foreground"
        >
          Getting ready...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
